module.exports = __webpack_public_path__ + "static/media/fla.29ef85e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/filetype/fla.png
// module id = 2554
// module chunks = 0